import React, { useRef, useMemo, useState, useEffect } from 'react'
import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
import JoditEditor from 'jodit-react';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';
import Swal from 'sweetalert2'
import axios from 'axios';
import api from '../../API/api';
import ViewFaculty from '../table/viewFaculty';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Loader from '../panel/loader';
import AchievmentForm from '../form/achievmentForm'

import { Helmet } from "react-helmet";


const AddFacalty = () => {



    const navigation = useNavigate();
    const params = useParams()
    const school_id = params.s_id;

    const [courseOverview, setCourseOverview] = useState();
    const [careerOpportunities, setCareerOpportunities] = useState();

    const [formdata, setFormdata] = useState({
        name: '',
        designation: '',
        qualification: '',


    })

    const [photo, setPhoto] = useState();


    const handlePhoto = (e) => {
        setPhoto(e.target.files[0]);
    }


    const [open, setOpen] = React.useState(false);
    const [load, setLoad] = useState(false);
    const [modalData , setModalData] = useState()

    const [courses, setCourses] = useState();
    const [school, setSchool] = useState();
    const [achive , setAchive] = useState(false);
    const [faculty, setFaculty] = useState();


    useEffect(() => {
        getCourses()
        getFaculty()
    }, []);


    const getFaculty = () => {
        setLoad(true)
        api.getFaculty(school_id).then((res) => {
            // console.log("res", res);
            setFaculty(res.data.faculties);
            setLoad(false)
        })
            .catch((err) => {
                // console.log(err.responseই);
            })

    }


    const getCourses = () => {
        setLoad(true)
        api.getCourses(school_id).then((res) => {
            setCourses(res.data.courses)
            setSchool(res.data.school)
            setLoad(false)
            // console.log(res);
        })
            .catch((err) => {
                // console.log(err.response);
            })

    }

    const handleClickOpen = (e) => {
        setOpen(true);
        setFormdata();
        setModalData(e)
        
        // console.log(e, 'eaeks edit');
    };
    const handleOpenAChive = e =>{setAchive(true); setModalData(e) }
    const handleClose = () => {
        setOpen(false);
        setAchive(false);
    };

    const handleForm = (e) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        })
    }

    const submitData = () => {
        // console.log(formdata && formdata);
        // console.log(photo);
        // return;

        setLoad(true)
        const postData = new FormData();
        postData.append('school_id', school_id);
        postData.append('name', formdata.name);
        postData.append('designation', formdata.designation);
        postData.append('qualification', formdata.qualification);
        postData.append('photo', photo);



        axios.post(`${process.env.REACT_APP_MAIN_API}saveFaculty`, postData)
            // axios.post(`http://127.0.0.1:8000/api/saveFaculty`, postData)
            .then((res) => {
                // console.log(res);
                setLoad(false)

                getFaculty();
                handleClose();
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })
            })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 320,
        triggerChangeEvent: true,
        readonly: false,
    }

    const form = () => {
        return (
            <>
                <div>
                    <div className="row p-3">
                        <div className="col-md-6 pb-3">
                            <label htmlFor=""> Faculty Name </label>
                            <input type="text" className='form-control' name="name" value={formdata?.name} onChange={handleForm} />
                        </div>
                        <div className="col-md-6 pb-3">
                            <label htmlFor=""> Designation </label>
                            <input type="text" className='form-control' name="designation" value={formdata?.designation} onChange={handleForm} />
                        </div>
                        <div className="col-md-6 pb-3">
                            <label htmlFor="">Hightest Educational Qualification </label>
                            <input type="text" className='form-control' name="qualification" value={formdata?.qualification} onChange={handleForm} />
                        </div>
                        <div className="col-md-6 pb-3">
                            <label htmlFor=""> Photo </label>
                            <input type="file" className='form-control' name="photo" onChange={handlePhoto} />
                        </div>
                        <div className="text-center m-3">
                            <Button variant='contained' onClick={submitData}>Save</Button>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    useEffect(() => {
        setFormdata(modalData)
        // console.log(modalData && modalData,'dasbdhsabjdhbsa')
    },[modalData])

    const deleteFaculty=(data)=>{
        // console.log("rrr", data);

        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          }).then((result) => {
            if (result.isConfirmed) {
              api
                .deleteFaculty(data.id)
                .then((res) => {
                //   console.log("res", res);
                  if (res.data.status === 200) {
                    getFaculty();
                    Swal.fire({
                      title: "Deleted!",
                      text: "Your data has been deleted.",
                      icon: "success",
                    });
                  }
                })
                .catch((err) => {
                //   console.log(err);
                });
      
              // props.deleteStudent(data)
              //   Swal.fire({
              //     title: "Deleted!",
              //     text: "Your file has been deleted.",
              //     icon: "success"
              //   });
            }
          });
    }


    return (
        <>

            <div className="row">
                <Paper>
                    <div className="col-12 d-flex justify-content-between p-2">
                        <Button variant='contained' onClick={() => navigation(-1)}>Back</Button>
                        <Button variant='contained' onClick={handleClickOpen}>+Add Faculty</Button>
                    </div>
                    <FormDialog form={form()} title='Add Faculty' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                    <FormDialog form={<AchievmentForm  handleClose={handleClose} modalData={modalData}  type="faculty" edit="no"/>}
                     title='Add Achievement' size={'md'} open={achive} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                </Paper>
                {load &&
                    <Loader />
                }
                <Paper>
                    <div className="col-12">
                        <ViewFaculty faculty={faculty} school={school} handleClickOpen={handleClickOpen} setModalData={setModalData}
                        handleOpenAChive={handleOpenAChive} deleteFaculty={deleteFaculty} />
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default AddFacalty;